export const INSTAGRAM_URL =
  'https://www.instagram.com/djm_roofing_and_build/?hl=en';

export const DJM_BUILD_URL = 'https://djmbuild.co.uk';

export const CONSULTING_URL = 'https://anchorparkconsulting.com';

export const GM_CONTRACTORS_URL = 'https://gmcontractorsdevon.co.uk';

export const R_A_ROWE_URL = 'https://www.rarowe.co.uk/';

export const CONTACT_EMAIL = 'anchorparkhomes@gmail.com';

export const COMPANY = {
  name: 'ANCHORPARK HOMES LTD',
  number: '17198903',
  companiesHouseUrl:
    'https://find-and-update.company-information.service.gov.uk/company/17198903',
};
